module.exports = __webpack_public_path__ + "img/big.134d231a.jpg";